import BillOfProcessDetail from '@/models/BillOfProcess/BillOfProcessDetail';

export default class BillOfProcessDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.sequence = '';
		this.billOfProcessId  = '';
		this.billOfProcessPartNumber = '';
		this.machineId  = '';
		this.machineCode = '';
		this.subProcessId  = '';
		this.subProcessCode = '';
		this.diesOrJigNumber = '';
		this.subProcessNumber = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			sequence : '0',
			billOfProcessId : '0',
			billOfProcessPartNumber : '0',
			machineId : '0',
			machineCode : '0',
			subProcessId : '0',
			subProcessCode : '0',
			diesOrJigNumber : '0',
			subProcessNumber : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}